<template>
    <div class="wapper">
        <el-container style="100%">
            <el-main style="background: #fff; margin-left: 10px">
                <div class="table-wrap">
                    <div class="handle-box3">
                        <el-form :inline="true" class="demo-form-inline">
                            <el-form-item label="搜索：">
                                <el-input
                                        v-model="searchForm.name"
                                        placeholder="姓名"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="">
                                <el-input
                                        v-model="searchForm.type"
                                        placeholder="类型"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="">
                                <el-input
                                        v-model="searchForm.code"
                                        placeholder="码值"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="">
                                <el-date-picker
                                        v-model="searchForm.startDate"
                                        type="datetime"
                                        placeholder="开始日期"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="">
                                <el-date-picker
                                        v-model="searchForm.endDate"
                                        type="datetime"
                                        placeholder="开始日期"
                                ></el-date-picker>
                            </el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="getData"
                            >搜索
                            </el-button>
                            <el-button
                                    type="primary"
                                    icon="el-icon-export"
                                    @click="exportExcel()"
                            >导出
                            </el-button>
                            <el-button
                                    type="danger"
                                    icon="el-icon-export"
                                    @click="deleteData"
                            >全部重试
                            </el-button>
                        </el-form>
                    </div>
                    <div class="tabbox">
                        <el-table
                                :data="dataList"
                                height="100%"
                                border
                                class="tabbox"
                                ref="multipleTable"
                                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                        >
                            <el-table-column
                                    type="selection"
                                    width="55"
                                    align="center"
                            ></el-table-column>
                            <el-table-column prop="typeName" min-width="100" label="类型" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.type }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" min-width="100" label="门禁点" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.remark }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="time" min-width="150" label="操作时间" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.regTime }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="证件id" min-width="120" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.attendeeId }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="证件编号" min-width="120" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.badgeNumber }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="回调地址" min-width="200" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.url }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="返回数据" min-width="200" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.response }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="180" align="center">
                                <template slot-scope="scope">
                                    <el-button
                                            type="text"
                                            class="red"
                                            @click="handleDelete(scope.$index, scope.row)"
                                    >重试
                                    </el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <DeleteDialog
                        :delVisible="delVisible"
                        @deleteData="deleteData"
                        @handleCloseVisible="handleCloseVisible"
                ></DeleteDialog>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import Blob from "../../../components/common/Blob";
    import Export2Excel from "../../../components/common/Export2Excel";
    import DeleteDialog from "../../../components/public/DeleteConfim";

    export default {
        data() {
            return {
                //表格高度适配
                searchForm: {
                    name: "",
                    code: "",
                    type: "",
                    endDate: new Date(
                        new Date(new Date().toLocaleDateString()).getTime() +
                        24 * 60 * 60 * 1000 -
                        1
                    ),
                    startDate: new Date(
                        new Date(new Date().toLocaleDateString()).getTime()
                    ),
                    projectId: localStorage.getItem("project_Id"),
                },
                id: "",
                delVisible: false,
                tabheight: "",
                dataList: [],
            };
        },
        mounted() {
            // this.tabheight=(this.$refs.getheight.offsetHeight-165)
        },
        created() {
            this.getData();
        },
        methods: {
            handleDelete(index, row) {
                this.id = row.id;
                this.delVisible = true;
            },
            deleteData() {
                if (this.id) {
                    this.$axios.delete(`/Attendee/${this.id}`).then((res) => {
                        if (res.data.hasError) {
                            this.$message.error(res.data.message);
                        } else {
                            this.$message.success("重试成功！");
                            this.delVisible = false;
                            this.getData();
                        }
                    });
                } else {
                    this.$axios.post(`/Attendee/${this.searchForm.projectId}`).then((res) => {
                        if (res.data.hasError) {
                            this.$message.error(res.data.message);
                        } else {
                            this.$message.success("重试成功！");
                            this.delVisible = false;
                            this.getData();
                        }
                    });
                }
            },
            handleCloseVisible() {
                this.id = "";
                this.delVisible = false;
            },
            getData() {
                this.$axios.post("/Attendee/Search/", this.searchForm).then((res) => {
                    if (res.data.hasError == false) {
                        this.dataList = [...res.data.data];
                        this.total = res.data.total;
                    }
                });
            },
            // 导出表格
            exportExcel() {
                require.ensure([], () => {
                    const {
                        export_json_to_excel,
                    } = require("../../../components/common/Export2Excel");

                    const tHeader = [
                        "类型",
                        "门禁点",
                        "时间",
                        "姓名",
                        "证件id",
                        "证件编号",
                        "回调地址",
                        "返回数据",
                    ]; // 上面设置Excel的表格第一行的标题

                    const filterVal = [
                        "type",
                        "remark",
                        "regTime",
                        "name",
                        "attendeeId",
                        "badgeNumber",
                        "url",
                        "response",
                    ]; // 上面的index、nickName、name是tableData里对象的属性

                    const list = this.dataList; //把data里的tableData存到list

                    const data = this.formatJson(filterVal, list);

                    export_json_to_excel(tHeader, data, "回调记录_" + new Date().getTime()); //标题，数据，文件名
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },
        },
        components: {
            DeleteDialog,
            Blob,
            Export2Excel,
        },
    };
</script>

<style lang="scss">

    .el-main {
        border-radius: 5px;
        position: relative;
    }

    .table-wrap {
        height: 100%;
        margin-left: 10px;
    }
</style>